"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDom = require("react-dom");

var S = _interopRequireWildcard(require("./ModalSlider.style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CloseIcon = function CloseIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.933 23.645a1.21 1.21 0 0 0 1.712-1.712L15.712 14l7.933-7.933a1.21 1.21 0 0 0-1.712-1.712L14 12.288 6.067 4.355a1.21 1.21 0 1 0-1.712 1.712L12.288 14l-7.933 7.933a1.21 1.21 0 0 0 1.712 1.712L14 15.712l7.933 7.933z"
  }));
};

CloseIcon.defaultProps = {
  width: "28",
  height: "28",
  viewBox: "0 0 28 28",
  fill: "#9DAFBD",
  xmlns: "http://www.w3.org/2000/svg"
};

var ModalSlider = function ModalSlider(_ref) {
  var show = _ref.show,
      onClose = _ref.onClose,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["show", "onClose", "children"]);

  (0, _react.useLayoutEffect)(function () {
    document.body.style.overflow = show ? 'hidden' : 'unset';
  }, [show]);

  var modal = show && /*#__PURE__*/_react["default"].createElement(S.Backdrop, {
    show: show
  }, /*#__PURE__*/_react["default"].createElement(S.Paper, props, /*#__PURE__*/_react["default"].createElement(S.CloseButton, {
    small: true,
    variant: "primary",
    onClick: onClose
  }, /*#__PURE__*/_react["default"].createElement(CloseIcon, null)), /*#__PURE__*/_react["default"].createElement(S.Body, null, children)));

  return /*#__PURE__*/(0, _reactDom.createPortal)(modal, document.body);
};

ModalSlider.propTypes = {
  show: _propTypes["default"].bool,
  onClose: _propTypes["default"].func.isRequired,
  children: _propTypes["default"].node.isRequired
};
var _default = ModalSlider;
exports["default"] = _default;